var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "spring-spinner", style: _vm.spinnerStyle }, [
    _c(
      "div",
      { staticClass: "spring-spinner-part top", style: _vm.spinnerPartStyle },
      [
        _c("div", {
          staticClass: "spring-spinner-rotator",
          style: _vm.rotatorStyle
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "spring-spinner-part bottom",
        style: _vm.spinnerPartStyle
      },
      [
        _c("div", {
          staticClass: "spring-spinner-rotator",
          style: _vm.rotatorStyle
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }